// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, firebaseApp } from "../firebase";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import LogoutModal from "../components/Modal/LogoutModal";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // Firebase auth user
  const [userData, setUserData] = useState(null); // Firestore user doc
  const [userRef, setUserRef] = useState(null);
  const [logoutBtn, setLogoutBtn] = useState(false);
  const [loading, setLoading] = useState(true);
  const db = getFirestore(firebaseApp);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        // fetch Firestore doc from /Users/{uid}
        const userRef = doc(db, "Users", currentUser.uid);
        setUserRef(userRef)
        const snap = await getDoc(userRef);

        if (snap.exists()) {
          setUserData(snap.data());
        } else {
          setUserData(null); // no doc found
        }
      } else {
        setUserData(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);


const logout = async () => {
  try {
    await signOut(auth);
    setLogoutBtn(true); // show modal first
    setUserRef(null)
  } catch (err) {
    console.error("Logout failed", err);
  }
};
const handleClose = () => {
  setLogoutBtn(false); // hide modal
  navigate("/");       // then navigate
};

  return (
    <AuthContext.Provider value={{ user, userData, userRef, logout, loading }}>
      {!loading && children}
      {logoutBtn && <LogoutModal onClose={handleClose} />}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}